<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl mb-0">
          Controle WhatsApp
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-tabs v-model="activeTab" background-color="transparent" class="mb-2">
          <v-tab>Campanhas</v-tab>
          <v-tab>Canais Solicitados</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card outlined>
              <v-card-text>
                <v-data-table
              :headers="headers"
              :items="campaigns"
              :loading="loading"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Itens por página:',
              }"
              class="elevation-0"
              no-data-text="Nenhuma campanha encontrada"
              loading-text="Carregando dados..."
              item-key="id"
            >
              <!-- Ações -->
              <template #item.actions="{ item }">
                <v-btn
                  icon
                  small
                  color="info"
                  title="Visualizar"
                  @click="openCampaignDetail(item)"
                >
                  <v-icon small>
                    {{ icons.mdiEye }}
                  </v-icon>
                </v-btn>
              </template>
              <!-- Data criação -->
              <template #item.date="{ item }">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium">{{ formatDate(item.date) }}</span>
                  <span class="text-xs text--secondary">{{ formatTime(item.date) }}</span>
                </div>
              </template>

              <!-- Nome Campanha -->
              <template #item.campaignName="{ item }">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ item.campaignName }}
                </div>
              </template>

              <!-- Usuário -->
              <template #item.userName="{ item }">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ item.userName || '-' }}
                </div>
              </template>

              <!-- Marca -->
              <template #item.brandName="{ item }">
                <div v-if="item.brandName" class="d-flex flex-column">
                  <div class="text-truncate font-weight-medium" style="max-width: 200px;">
                    {{ item.brandName }}
                  </div>
                  <span
                    v-if="item.brandChannelPhone"
                    class="text-caption text--secondary"
                  >
                    {{ item.brandChannelPhone }}
                  </span>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Foto de Perfil -->
              <template #item.profileImage="{ item }">
                <div v-if="item.idfileProfileImage" class="d-flex align-center">
                  <v-avatar
                    size="40"
                    class="mr-2 cursor-pointer"
                    @click="downloadImage(item.idfileProfileImage, item.campaignName + '_profile')"
                  >
                    <img
                      :src="getPublicImageUrl(item.idfileProfileImage)"
                      :alt="'Foto de perfil - ' + item.campaignName"
                      @error="handleImageError"
                    >
                  </v-avatar>
                  <a
                    href="#"
                    class="text-decoration-none info--text text-caption"
                    @click.prevent="downloadImage(item.idfileProfileImage, item.campaignName + '_profile')"
                  >
                    <v-icon small>{{ icons.mdiDownload }}</v-icon>
                  </a>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Nome do Perfil -->
              <template #item.profileName="{ item }">
                <div v-if="item.profileName" class="d-flex align-center">
                  <div class="text-truncate" style="max-width: 200px;">
                    {{ item.profileName }}
                  </div>
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    @click="copyToClipboard(item.profileName)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Base -->
              <template #item.base="{ item }">
                <v-chip
                  small
                  color="primary"
                  outlined
                  class="cursor-pointer"
                  @click="downloadContactsCsv(item)"
                >
                  {{ item.quantity || 0 }} contatos
                </v-chip>
              </template>

              <!-- Horário -->
              <!-- Agendamento -->
              <template #item.scheduledDate="{ item }">
                <div v-if="getCampaignScheduledDate(item)" class="d-flex flex-column">
                  <span class="font-weight-medium">{{ formatDate(getCampaignScheduledDate(item)) }}</span>
                  <span class="text-xs text--secondary">{{ formatTime(getCampaignScheduledDate(item)) }}</span>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Link da Mídia -->
              <template #item.mediaImage="{ item }">
                <div v-if="item.idFileImageMessage" class="d-flex align-center">
                  <v-avatar
                    size="40"
                    class="mr-2 cursor-pointer"
                    @click="downloadImage(item.idFileImageMessage, item.campaignName + '_media')"
                  >
                    <img
                      :src="getPublicImageUrl(item.idFileImageMessage)"
                      :alt="'Mídia - ' + item.campaignName"
                      @error="handleImageError"
                    >
                  </v-avatar>
                  <a
                    href="#"
                    class="text-decoration-none info--text text-caption"
                    @click.prevent="downloadImage(item.idFileImageMessage, item.campaignName + '_media')"
                  >
                    <v-icon small>{{ icons.mdiDownload }}</v-icon>
                  </a>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Copy -->
              <template #item.messageContent="{ item }">
                <div v-if="item.messageContent" class="d-flex align-start">
                  <div
                    class="message-content-preview"
                    style="max-width: 260px; max-height: 96px; overflow: auto; white-space: pre-wrap; word-break: break-word;"
                  >{{ item.messageContent }}</div>
                  <v-btn
                    icon
                    x-small
                    class="ml-1 flex-shrink-0"
                    @click="copyToClipboard(item.messageContent)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Link de direcionamento -->
              <template #item.buttonLink="{ item }">
                <div v-if="item.buttonLink" class="d-flex align-center">
                  <a
                    :href="item.buttonLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-decoration-none info--text text-truncate"
                    style="max-width: 150px;"
                  >
                    {{ item.buttonLink }}
                  </a>
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    @click="copyToClipboard(item.buttonLink)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Status do disparo -->
              <template #item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item.status)"
                  small
                  label
                  dark
                >
                  {{ getStatusLabel(item.status) }}
                </v-chip>
              </template>
            </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card outlined>
              <v-card-text>
                <div class="d-flex justify-end mb-3">
                  <v-btn
                    color="primary"
                    outlined
                    @click="openCreateChannelDialog"
                  >
                    Cadastrar Canal
                    <v-icon right>
                      {{ icons.mdiPlus }}
                    </v-icon>
                  </v-btn>
                </div>
                <v-data-table
                  :headers="channelHeaders"
                  :items="channelRequests"
                  :loading="channelLoading"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-options': [10, 25, 50, 100],
                    'items-per-page-text': 'Itens por página:',
                  }"
                  class="elevation-0"
                  no-data-text="Nenhuma solicitação de canal encontrada"
                  loading-text="Carregando dados..."
                  item-key="id"
                >
                  <template #item.date="{ item }">
                    <div class="d-flex flex-column">
                      <span class="font-weight-medium">{{ formatDate(item.createdAt) }}</span>
                      <span class="text-xs text--secondary">{{ formatTime(item.createdAt) }}</span>
                    </div>
                  </template>

                  <template #item.userName="{ item }">
                    <div class="text-truncate" style="max-width: 200px;">
                      {{ item.userName || '-' }}
                    </div>
                  </template>

                  <template #item.profileName="{ item }">
                    <div class="text-truncate" style="max-width: 200px;">
                      {{ item.profileName || '-' }}
                    </div>
                  </template>

                  <template #item.profileImage="{ item }">
                    <div v-if="item.idfileProfileImage" class="d-flex align-center">
                      <v-avatar
                        size="40"
                        class="mr-2 cursor-pointer"
                        @click="downloadImage(item.idfileProfileImage, item.profileName + '_profile')"
                      >
                        <img
                          :src="getPublicImageUrl(item.idfileProfileImage)"
                          :alt="'Foto de perfil - ' + item.profileName"
                          @error="handleImageError"
                        >
                      </v-avatar>
                    </div>
                    <span v-else class="text--secondary text-caption">-</span>
                  </template>

                  <template #item.channelPhone="{ item }">
                    <span>{{ item.channelPhone || '-' }}</span>
                  </template>

                  <template #item.status="{ item }">
                    <v-chip
                      :color="getChannelStatusColor(item.status)"
                      small
                      label
                      dark
                    >
                      {{ getChannelStatusLabel(item.status) }}
                    </v-chip>
                  </template>

                  <template #item.actions="{ item }">
                    <v-btn
                      v-if="item.status === 1 || item.status === 2"
                      icon
                      small
                      color="success"
                      title="Aprovar canal"
                      @click="openApproveChannelDialog(item)"
                    >
                      <v-icon small>{{ icons.mdiCheckCircle }}</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 1 || item.status === 2"
                      icon
                      small
                      color="error"
                      title="Recusar solicitação"
                      @click="openRefuseChannelDialog(item)"
                    >
                      <v-icon small>{{ icons.mdiCancel }}</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- Dialog de confirmação -->
    <v-dialog
      v-model="confirmDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{ confirmDialogTitle }}
        </v-card-title>
        <v-card-text>
          {{ confirmDialogMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="confirmDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :color="confirmDialogType === 'cancel' ? 'error' : 'success'"
            text
            @click="confirmAction"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de detalhes da campanha -->
    <v-dialog
      v-model="dialogCampaignDetail"
      max-width="800"
    >
      <v-card>
        <v-card-title class="headline">
          Detalhes da campanha
        </v-card-title>
        <v-card-text v-if="selectedCampaign">
          <v-row>
            <v-col cols="12" md="6">
              <p class="mb-1"><strong>Nome da Campanha:</strong></p>
              <p class="mb-3">{{ selectedCampaign.campaignName }}</p>

              <p class="mb-1"><strong>Marca:</strong></p>
              <p class="mb-3">
                <template v-if="selectedCampaign.brandName">
                  {{ selectedCampaign.brandName }}
                  <span
                    v-if="selectedCampaign.brandChannelPhone"
                    class="text--secondary"
                  >
                    ({{ selectedCampaign.brandChannelPhone }})
                  </span>
                </template>
                <span v-else>-</span>
              </p>

              <p class="mb-1"><strong>Data de criação:</strong></p>
              <p class="mb-3">{{ formatDate(selectedCampaign.date) }} {{ formatTime(selectedCampaign.date) }}</p>

              <p class="mb-1"><strong>Agendamento:</strong></p>
              <p class="mb-3">
                <template v-if="getCampaignScheduledDate(selectedCampaign)">
                  {{ formatDate(getCampaignScheduledDate(selectedCampaign)) }}
                  {{ formatTime(getCampaignScheduledDate(selectedCampaign)) }}
                </template>
                <span v-else>-</span>
              </p>

              <p class="mb-1"><strong>Base:</strong></p>
              <p class="mb-3">{{ selectedCampaign.quantity || 0 }} contatos</p>

            
            </v-col>
            <v-col cols="12" md="6">
              <p class="mb-1"><strong>Copy:</strong></p>
              <p
                class="mb-3"
                style="white-space: pre-wrap; word-break: break-word;"
              >{{ selectedCampaign.messageContent || '-' }}</p>

              <p class="mb-1"><strong>Link de direcionamento:</strong></p>
              <p class="mb-3">
                <a
                  v-if="selectedCampaign.buttonLink"
                  :href="selectedCampaign.buttonLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ selectedCampaign.buttonLink }}
                </a>
                <span v-else>-</span>
              </p>
              <p class="mb-1"><strong>Status:</strong></p>
              <v-chip
                :color="getStatusColor(selectedCampaign.status)"
                small
                label
                dark
              >
                {{ getStatusLabel(selectedCampaign.status) }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <div class="mt-n2 mb-4">
            <p class="mb-2 font-weight-medium">
              Upload do relatório
            </p>
            <input
              ref="generalReportFile"
              type="file"
              accept=".xlsx,.xls,.csv,.docx,.txt,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain"
              hidden
              @change="handleReportFile('general', $event)"
            />
            <div
              class="drop-zone"
              :class="{ 'drop-zone-active': uploads.general.isDragging }"
              @dragover.prevent="handleDragOver('general', $event)"
              @dragleave.prevent="handleDragLeave('general', $event)"
              @drop.prevent="handleDrop('general', $event)"
            >
              <v-btn
                color="primary"
                outlined
                block
                large
                class="dashed-border media-upload-btn"
                :disabled="uploads.general.loading"
                @click="$refs.generalReportFile.click()"
              >
                <v-icon left>
                  {{ icons.mdiPaperclip }}
                </v-icon>
                {{ uploads.general.isDragging ? 'Solte o arquivo aqui' : 'Clique ou arraste o relatório (Excel, CSV, DOCX ou TXT)' }}
              </v-btn>
            </div>
            
            <!-- Indicador de loading -->
            <div v-if="uploads.general.loading" class="mt-2 text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                size="20"
              />
              <span class="ml-2">Processando arquivo...</span>
            </div>

            <!-- Preview do arquivo selecionado -->
            <div v-if="uploads.general.fileSelected && !uploads.general.loading" class="mt-3">
              <v-card outlined class="pa-3">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon :color="getFileTypeColor(uploads.general.fileType)" class="mr-2" size="32">
                      {{ getMediaIcon(uploads.general.fileType) }}
                    </v-icon>
                    <div>
                      <div class="font-weight-medium">{{ uploads.general.fileName }}</div>
                      <div class="text-caption text--secondary">
                        {{ formatFileSize(uploads.general.fileSelected.size) }} • {{ getFileTypeLabel(uploads.general.fileType) }}
                      </div>
                    </div>
                  </div>
                  <v-btn
                    icon
                    small
                    @click="removeReportFile('general')"
                  >
                    <v-icon small>{{ icons.mdiCancel }}</v-icon>
                  </v-btn>
                </div>
                
                <!-- Preview para arquivos de texto -->
                <div v-if="uploads.general.fileType === 'txt' || uploads.general.fileType === 'csv'" class="mt-2">
                  <v-card outlined class="pa-2" style="max-height: 200px; overflow-y: auto;">
                    <pre class="text-caption mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{ uploads.general.previewContent }}</pre>
                  </v-card>
                </div>
                
                <!-- Preview para outros tipos (mostrar apenas informações) -->
                <div v-else class="mt-2">
                  <v-alert
                    type="info"
                    dense
                    outlined
                  >
                    Arquivo {{ getFileTypeLabel(uploads.general.fileType) }} selecionado e pronto para upload
                  </v-alert>
                </div>
              </v-card>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            @click="dialogCampaignDetail = false"
          >
            Fechar
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            contained
            :disabled="!selectedCampaign || !canCancel(selectedCampaign)"
            @click="cancelCampaign(selectedCampaign)"
          >
            {{ isSelectedCampaignCancelled ? 'Atualizar relatório' : 'Cancelar campanha' }}
          </v-btn>
          <v-btn
            color="primary"
            contained
            :disabled="!selectedCampaign || !canApprove(selectedCampaign)"
            @click="approveCampaign(selectedCampaign)"
          >
            Aprovar campanha
          </v-btn>
          <v-btn
            color="success"
            contained
            :disabled="!selectedCampaign || !canFinalize(selectedCampaign)"
            @click="finalizeCampaign(selectedCampaign)"
          >
            {{ isSelectedCampaignCompleted ? 'Atualizar relatório' : 'Finalizar campanha' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal aprovar campanha -->
    <v-dialog
      v-model="dialogApproveCampaign"
      max-width="520"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Aprovar campanha
        </v-card-title>
        <v-card-text>
          <p class="mb-3">
            Defina a nova data e horário de envio da campanha
            <strong>{{ selectedCampaign && selectedCampaign.campaignName }}</strong>.
          </p>
          <v-datetime-picker
            v-model="approveCampaignScheduledDate"
            :text-field-props="{
              outlined: true,
              dense: true,
              placeholder: 'Selecione a data e hora de envio',
              label: 'Data e horário de envio *',
              min: getMinApproveScheduledDate(),
            }"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
            hide-details
          >
            <template slot="dateIcon">
              <v-icon>{{ icons.mdiCalendarMonthOutline }}</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>{{ icons.mdiClockTimeElevenOutline }}</v-icon>
            </template>
          </v-datetime-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="approveCampaignLoading"
            @click="closeApproveCampaignDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="approveCampaignLoading"
            @click="confirmApproveCampaign"
          >
            Aprovar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal cadastrar canal -->
    <v-dialog
      v-model="dialogCreateChannel"
      max-width="560"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Cadastrar Canal WhatsApp
        </v-card-title>
        <v-card-text>
          <validation-observer ref="formCreateChannel">
            <validation-provider
              v-slot="{ errors }"
              name="Usuário"
              rules="required"
              vid="createChannelUserId"
            >
              <v-autocomplete
                v-model="createChannelForm.userId"
                :items="users"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                outlined
                dense
                item-text="value"
                item-value="id"
                label="Usuário *"
                class="mb-3"
              />
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="Nome de Exibição"
              rules="required"
              vid="createChannelProfileName"
            >
              <v-text-field
                v-model="createChannelForm.profileName"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                dense
                outlined
                label="Nome de Exibição *"
                class="mb-3"
              />
            </validation-provider>

            <p class="mb-2 text-sm">
              Foto de perfil *
            </p>
            <input
              ref="createChannelProfilePhotoFile"
              type="file"
              accept="image/*"
              class="d-none"
              @change="handleCreateChannelProfilePhoto"
            >
            <v-btn
              color="primary"
              outlined
              small
              @click="$refs.createChannelProfilePhotoFile.click()"
            >
              <v-icon left>
                {{ icons.mdiImage }}
              </v-icon>
              {{ createChannelForm.profilePhoto ? 'Alterar Foto' : 'Selecionar Foto' }}
            </v-btn>

            <div
              v-if="createChannelProfilePhotoPreviewUrl"
              class="mt-3 d-flex align-center"
            >
              <v-avatar
                size="56"
                class="mr-3"
              >
                <img
                  :src="createChannelProfilePhotoPreviewUrl"
                  alt="Pré-visualização"
                >
              </v-avatar>
              <span class="text-sm">{{ createChannelProfilePhotoFileName }}</span>
            </div>
          </validation-observer>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="closeCreateChannelDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="channelActionLoading"
            @click="confirmCreateChannel"
          >
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal aprovar canal -->
    <v-dialog v-model="dialogApproveChannel" max-width="520">
      <v-card>
        <v-card-title class="headline">
          Aprovar canal WhatsApp
        </v-card-title>
        <v-card-text v-if="selectedChannelRequest">
          <p class="mb-2">
            <strong>Usuário:</strong> {{ selectedChannelRequest.userName || '-' }}
          </p>
          <p class="mb-4">
            <strong>Nome de exibição:</strong> {{ selectedChannelRequest.profileName }}
          </p>
          <v-text-field
            v-model="approveChannelForm.channelPhone"
            dense
            outlined
            label="Número do canal"
            placeholder="5511999999999"
          />
          <v-text-field
            v-model="approveChannelForm.channelExternalId"
            dense
            outlined
            label="ID externo do canal (opcional)"
          />
          <v-textarea
            v-model="approveChannelForm.adminObservation"
            dense
            outlined
            rows="3"
            label="Observação interna (opcional)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogApproveChannel = false">
            Cancelar
          </v-btn>
          <v-btn color="success" :loading="channelActionLoading" @click="confirmApproveChannel">
            Aprovar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal recusar canal -->
    <v-dialog v-model="dialogRefuseChannel" max-width="520">
      <v-card>
        <v-card-title class="headline">
          Recusar solicitação de canal
        </v-card-title>
        <v-card-text v-if="selectedChannelRequest">
          <p class="mb-4">
            <strong>Usuário:</strong> {{ selectedChannelRequest.userName || '-' }}
          </p>
          <v-textarea
            v-model="refuseChannelForm.refusedReason"
            dense
            outlined
            rows="3"
            label="Motivo da recusa *"
          />
          <v-textarea
            v-model="refuseChannelForm.adminObservation"
            dense
            outlined
            rows="2"
            label="Observação interna (opcional)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogRefuseChannel = false">
            Cancelar
          </v-btn>
          <v-btn color="error" :loading="channelActionLoading" @click="confirmRefuseChannel">
            Recusar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiContentCopy,
  mdiCheckCircle,
  mdiCancel,
  mdiEye,
  mdiDownload,
  mdiFileDocument,
  mdiFileExcel,
  mdiFile,
  mdiFileDocumentOutline,
  mdiPaperclip,
  mdiPlus,
  mdiImage,
  mdiCalendarMonthOutline,
  mdiClockTimeElevenOutline,
} from '@mdi/js'
import { mapActions, mapState } from 'vuex'
import DatetimePicker from 'vuetify-datetime-picker'
import Vue from 'vue'

Vue.use(DatetimePicker)

export default {
  name: 'WhatsAppControl',

  data() {
    const createUploadState = () => ({
      fileSelected: null,
      fileName: '',
      fileType: '',
      previewUrl: '',
      loading: false,
      isDragging: false,
      previewContent: '',
    })

    return {
      activeTab: 0,
      icons: {
        mdiContentCopy,
        mdiCheckCircle,
        mdiCancel,
        mdiEye,
        mdiDownload,
        mdiFileDocument,
        mdiFileExcel,
        mdiFile,
        mdiFileDocumentOutline,
        mdiPaperclip,
        mdiPlus,
        mdiImage,
        mdiCalendarMonthOutline,
        mdiClockTimeElevenOutline,
      },
      loading: false,
      campaigns: [],
      channelRequests: [],
      channelLoading: false,
      channelActionLoading: false,
      dialogApproveChannel: false,
      dialogRefuseChannel: false,
      dialogCreateChannel: false,
      dialogApproveCampaign: false,
      approveCampaignScheduledDate: null,
      approveCampaignLoading: false,
      selectedChannelRequest: null,
      users: [],
      createChannelForm: {
        userId: null,
        profileName: '',
        profilePhoto: null,
      },
      createChannelProfilePhotoFileName: '',
      createChannelProfilePhotoPreviewUrl: '',
      approveChannelForm: {
        channelPhone: '',
        channelExternalId: '',
        adminObservation: '',
      },
      refuseChannelForm: {
        refusedReason: '',
        adminObservation: '',
      },
      dialogCampaignDetail: false,
      confirmDialog: false,
      confirmDialogTitle: '',
      confirmDialogMessage: '',
      confirmDialogType: '',
      selectedCampaign: null,
      uploads: {
        general: createUploadState(),
      },
    }
  },

  computed: {
    headers() {
      return [
        { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '80px' },
        { text: 'Data criação', value: 'date', align: 'left', sortable: true },
        { text: 'Nome Campanha', value: 'campaignName', align: 'left', sortable: true },
        { text: 'Usuário', value: 'userName', align: 'left', sortable: true },
        { text: 'Marca', value: 'brandName', align: 'left', sortable: true },
        { text: 'Foto de Perfil', value: 'profileImage', align: 'center', sortable: false },
        { text: 'Nome do Perfil', value: 'profileName', align: 'center', sortable: true },
        { text: 'Base', value: 'base', align: 'center', sortable: true },
        { text: 'Agendamento', value: 'scheduledDate', align: 'left', sortable: true },
        { text: 'Link da Mídia', value: 'mediaImage', align: 'center', sortable: false },
        { text: 'Copy', value: 'messageContent', align: 'left', sortable: false },
        { text: 'Link de direcionamento', value: 'buttonLink', align: 'left', sortable: false },
        { text: 'Status do disparo', value: 'status', align: 'center', sortable: true },
      ]
    },
    channelHeaders() {
      return [
        { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '100px' },
        { text: 'Data', value: 'date', align: 'left', sortable: true },
        { text: 'Usuário', value: 'userName', align: 'left', sortable: true },
        { text: 'Nome de Exibição', value: 'profileName', align: 'left', sortable: true },
        { text: 'Foto de Perfil', value: 'profileImage', align: 'center', sortable: false },
        { text: 'Canal', value: 'channelPhone', align: 'left', sortable: false },
        { text: 'Status', value: 'status', align: 'center', sortable: true },
      ]
    },
    isSelectedCampaignCompleted() {
      return this.selectedCampaign?.status === 'completed'
    },
    isSelectedCampaignCancelled() {
      return this.selectedCampaign?.status === 'cancelled'
    },
    hasReportFilesSelected() {
      return Boolean(this.uploads.general.fileSelected)
    },
  },

  watch: {
    dialogCampaignDetail(newValue) {
      if (!newValue) {
        // Limpar campos de upload quando o dialog for fechado
        this.resetAllUploads()
      }
    },
  },

  async created() {
    await Promise.all([
      this.fetchCampaigns(),
      this.fetchChannelRequests(),
      this.findUsers(),
    ])
  },

  methods: {
    ...mapActions('serviceWhatsapp', [
      'findAll',
      'finalize',
      'cancel',
      'approve',
      'findAllChannelRequests',
      'approveChannelRequest',
      'refuseChannelRequest',
      'createChannelRequest',
    ]),
    ...mapActions('user', {
      fetchUsers: 'find',
    }),

    async findUsers() {
      const users = await this.fetchUsers()
      if (!Array.isArray(users)) {
        this.users = []
        return
      }

      this.users = users.map(user => ({
        ...user,
        value: `${user.document ? String(this.$cpfCnpj.toMask(user.document)).concat(' - ', user.name) : user.name}`,
      }))
    },

    openCreateChannelDialog() {
      this.resetCreateChannelForm()
      this.dialogCreateChannel = true
    },

    closeCreateChannelDialog() {
      this.dialogCreateChannel = false
      this.resetCreateChannelForm()
    },

    resetCreateChannelForm() {
      if (this.createChannelProfilePhotoPreviewUrl) {
        URL.revokeObjectURL(this.createChannelProfilePhotoPreviewUrl)
      }
      this.createChannelForm = {
        userId: null,
        profileName: '',
        profilePhoto: null,
      }
      this.createChannelProfilePhotoFileName = ''
      this.createChannelProfilePhotoPreviewUrl = ''
      if (this.$refs.createChannelProfilePhotoFile) {
        this.$refs.createChannelProfilePhotoFile.value = ''
      }
      if (this.$refs.formCreateChannel) {
        this.$refs.formCreateChannel.reset()
      }
    },

    handleCreateChannelProfilePhoto(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return

      if (this.createChannelProfilePhotoPreviewUrl) {
        URL.revokeObjectURL(this.createChannelProfilePhotoPreviewUrl)
      }

      this.createChannelForm.profilePhoto = file
      this.createChannelProfilePhotoFileName = file.name
      this.createChannelProfilePhotoPreviewUrl = URL.createObjectURL(file)
    },

    async confirmCreateChannel() {
      const isValid = await this.$refs.formCreateChannel.validate()
      if (!isValid) {
        this.$notify('Preencha os campos obrigatórios.', 'error')
        return
      }

      if (!this.createChannelForm.profilePhoto) {
        this.$notify('Selecione uma foto de perfil para o canal.', 'error')
        return
      }

      this.channelActionLoading = true
      try {
        const status = await this.createChannelRequest({
          userId: this.createChannelForm.userId,
          profileName: this.createChannelForm.profileName,
          profilePhoto: this.createChannelForm.profilePhoto,
        })

        if (status === 201) {
          this.$notify('Canal cadastrado com sucesso', 'success')
          this.closeCreateChannelDialog()
          await this.fetchChannelRequests()
        } else {
          const message = status?.response?.data?.message
          this.$notify(message || 'Erro ao cadastrar canal', 'error')
        }
      } finally {
        this.channelActionLoading = false
      }
    },

    async fetchChannelRequests() {
      this.channelLoading = true
      try {
        const data = await this.findAllChannelRequests({ allUsers: true })
        this.channelRequests = Array.isArray(data) ? data : []
      } catch (error) {
        console.error('Erro ao buscar solicitações de canal:', error)
        this.$notify('Erro ao carregar solicitações de canal', 'error')
        this.channelRequests = []
      } finally {
        this.channelLoading = false
      }
    },

    openApproveChannelDialog(item) {
      this.selectedChannelRequest = item
      this.approveChannelForm = {
        channelPhone: item.channelPhone || '',
        channelExternalId: item.channelExternalId || '',
        adminObservation: item.adminObservation || '',
      }
      this.dialogApproveChannel = true
    },

    openRefuseChannelDialog(item) {
      this.selectedChannelRequest = item
      this.refuseChannelForm = {
        refusedReason: item.refusedReason || '',
        adminObservation: item.adminObservation || '',
      }
      this.dialogRefuseChannel = true
    },

    async confirmApproveChannel() {
      if (!this.selectedChannelRequest?.id) return

      this.channelActionLoading = true
      try {
        const result = await this.approveChannelRequest({
          id: this.selectedChannelRequest.id,
          channelPhone: this.approveChannelForm.channelPhone?.trim() || undefined,
          channelExternalId: this.approveChannelForm.channelExternalId?.trim() || undefined,
          adminObservation: this.approveChannelForm.adminObservation?.trim() || undefined,
        })

        if (result === true) {
          this.$notify('Canal aprovado com sucesso', 'success')
          this.dialogApproveChannel = false
          await this.fetchChannelRequests()
        } else {
          const message = result?.response?.data?.message
          this.$notify(message || 'Erro ao aprovar canal', 'error')
        }
      } finally {
        this.channelActionLoading = false
      }
    },

    async confirmRefuseChannel() {
      if (!this.selectedChannelRequest?.id) return
      if (!this.refuseChannelForm.refusedReason?.trim()) {
        this.$notify('Informe o motivo da recusa.', 'error')
        return
      }

      this.channelActionLoading = true
      try {
        const result = await this.refuseChannelRequest({
          id: this.selectedChannelRequest.id,
          refusedReason: this.refuseChannelForm.refusedReason.trim(),
          adminObservation: this.refuseChannelForm.adminObservation?.trim() || undefined,
        })

        if (result === true) {
          this.$notify('Solicitação recusada com sucesso', 'success')
          this.dialogRefuseChannel = false
          await this.fetchChannelRequests()
        } else {
          const message = result?.response?.data?.message
          this.$notify(message || 'Erro ao recusar solicitação', 'error')
        }
      } finally {
        this.channelActionLoading = false
      }
    },

    getChannelStatusLabel(status) {
      const map = {
        1: 'Pendente',
        2: 'Em análise',
        3: 'Aprovado',
        4: 'Recusado',
      }
      return map[status] || 'Pendente'
    },

    getChannelStatusColor(status) {
      const map = {
        1: 'orange',
        2: 'blue',
        3: 'success',
        4: 'error',
      }
      return map[status] || 'grey'
    },

    async fetchCampaigns() {
      this.loading = true
      try {
        const data = await this.findAll({ allUsers: true })
        
        // Se o backend retornar um array diretamente
        if (Array.isArray(data)) {
          this.campaigns = data
        } else if (data && Array.isArray(data.campaigns)) {
          // Se o backend retornar um objeto com propriedade campaigns
          this.campaigns = data.campaigns
        } else {
          // Dados mockados para desenvolvimento do frontend (quando backend não estiver pronto)
          this.campaigns = [
            {
              id: 1,
              date: new Date(),
              campaignName: 'Campanha Teste 1',
              idfileProfileImage: 1,
              idFileImageMessage: 2,
              quantity: 5000,
              scheduledDate: new Date(),
              messageContent: 'Mensagem de teste da campanha WhatsApp',
              buttonLink: 'https://example.com',
              status: 'pending',
            },
          ]
        }
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error)
        this.$notify('Erro ao carregar campanhas', 'error')
        // Dados mockados em caso de erro
        this.campaigns = []
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('pt-BR')
    },

    formatTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    getCampaignScheduledDate(item) {
      if (!item) return null
      return item.scheduledDate || item.sendDate || null
    },

    getPublicImageUrl(fileId) {
      if (!fileId) return ''
      return `${this.$axios.defaults.baseURL}/public/files/${fileId}`
    },

    async downloadImage(fileId, fileName) {
      try {
        const url = this.getPublicImageUrl(fileId)
        const response = await fetch(url)
        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = `${fileName || 'image'}.${blob.type.split('/')[1] || 'png'}`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
        this.$notify('Imagem baixada com sucesso', 'success')
      } catch (error) {
        console.error('Erro ao baixar imagem:', error)
        this.$notify('Erro ao baixar imagem', 'error')
      }
    },

    handleImageError(event) {
      event.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40"%3E%3Crect width="40" height="40" fill="%23ccc"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3E?%3C/text%3E%3C/svg%3E'
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$notify('Copiado para a área de transferência', 'success')
      }).catch(() => {
        this.$notify('Erro ao copiar link', 'error')
      })
    },

    async downloadContactsCsv(item) {
      if (!item.campaignId) {
        this.$notify('Campanha não possui ID para download', 'error')
        return
      }

      try {
        const response = await this.$axios.get(
          `whatsapp-campaign/${item.campaignId}/phone-numbers`
        )
        const phoneNumbers = Array.isArray(response.data) ? response.data : []

        if (!phoneNumbers.length) {
          this.$notify('Nenhum contato encontrado para esta campanha', 'warning')
          return
        }

        const normalizedRows = phoneNumbers.map(row => {
          if (row && typeof row === 'object') {
            return {
              number: String(row.number || '').trim(),
              variables:
                row.variables && typeof row.variables === 'object'
                  ? row.variables
                  : {},
            }
          }

          return {
            number: String(row || '').trim(),
            variables: {},
          }
        }).filter(row => row.number)

        if (!normalizedRows.length) {
          this.$notify('Nenhum contato encontrado para esta campanha', 'warning')
          return
        }

        const variableKeys = []
        normalizedRows.forEach(row => {
          Object.keys(row.variables || {}).forEach(key => {
            if (!variableKeys.includes(key)) {
              variableKeys.push(key)
            }
          })
        })

        const escapeCsv = value => {
          const text = String(value ?? '')
          if (/[",\n\r]/.test(text)) {
            return `"${text.replace(/"/g, '""')}"`
          }
          return text
        }

        const headers = ['NUMERO', ...variableKeys]
        const lines = [
          headers.join(','),
          ...normalizedRows.map(row => {
            const values = [
              row.number,
              ...variableKeys.map(key => row.variables[key] || ''),
            ]
            return values.map(escapeCsv).join(',')
          }),
        ]
        const fileContent = lines.join('\n')
        const fileName = `contatos-${item.campaignName || item.campaignId}.csv`
        const mimeType = 'text/csv;charset=utf-8'

        const blob = new Blob([fileContent], { type: mimeType })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$notify('Arquivo de contatos baixado com sucesso', 'success')
      } catch (error) {
        console.error('Erro ao baixar contatos:', error)
        this.$notify('Erro ao baixar contatos', 'error')
      }
    },

    getStatusColor(status) {
      const statusMap = {
        pending: 'warning',
        processing: 'info',
        completed: 'success',
        cancelled: 'error',
        failed: 'error',
      }
      return statusMap[status] || 'grey'
    },

    getStatusLabel(status) {
      const statusMap = {
        pending: 'Pendente',
        processing: 'Em processamento',
        completed: 'Finalizada',
        cancelled: 'Cancelada',
        failed: 'Falhou',
      }
      return statusMap[status] || 'Desconhecido'
    },

    openCampaignDetail(campaign) {
      this.selectedCampaign = campaign
      this.dialogCampaignDetail = true
    },

    canFinalize(item) {
      if (!item || !item.status) return false
      // Campanha finalizada: permitir atualizar relatórios com arquivo selecionado
      if (item.status === 'completed') {
        return this.hasReportFilesSelected
      }
      // Permitir finalizar apenas se estiver pendente ou em processamento
      return ['pending', 'processing'].includes(item.status)
    },

    canCancel(item) {
      if (!item || !item.status) return false
      // Campanha cancelada: permitir atualizar relatórios com arquivo selecionado
      if (item.status === 'cancelled') {
        return this.hasReportFilesSelected
      }
      // Permitir cancelar apenas se não estiver finalizada ou cancelada
      return !['completed', 'cancelled'].includes(item.status)
    },

    canApprove(item) {
      if (!item || !item.status) return false
      return item.status === 'pending'
    },

    finalizeCampaign(campaign) { 
      this.selectedCampaign = campaign
      const isUpdateReports = campaign.status === 'completed'
      this.confirmDialogTitle = isUpdateReports
        ? 'Atualizar Relatório'
        : 'Finalizar Campanha'
      this.confirmDialogMessage = isUpdateReports
        ? `Deseja atualizar o relatório da campanha "${campaign.campaignName}"?`
        : `Deseja realmente finalizar a campanha "${campaign.campaignName}"?`
      this.confirmDialogType = 'finalize'
      this.confirmDialog = true
    },

    cancelCampaign(campaign) {
      this.selectedCampaign = campaign
      const isUpdateReports = campaign.status === 'cancelled'
      this.confirmDialogTitle = isUpdateReports
        ? 'Atualizar Relatório'
        : 'Cancelar Campanha'
      this.confirmDialogMessage = isUpdateReports
        ? `Deseja atualizar o relatório da campanha "${campaign.campaignName}"?`
        : `Deseja realmente cancelar a campanha "${campaign.campaignName}"?`
      this.confirmDialogType = 'cancel'
      this.confirmDialog = true
    },

    approveCampaign(campaign) {
      this.selectedCampaign = campaign
      const currentDate = campaign.scheduledDate || campaign.sendDate || campaign.date
      this.approveCampaignScheduledDate = currentDate
        ? new Date(currentDate)
        : new Date()
      this.dialogApproveCampaign = true
    },

    closeApproveCampaignDialog() {
      this.dialogApproveCampaign = false
      this.approveCampaignScheduledDate = null
    },

    getMinApproveScheduledDate() {
      const minDate = new Date()
      return minDate.toISOString().slice(0, 16)
    },

    async confirmApproveCampaign() {
      if (!this.selectedCampaign) return

      if (!this.approveCampaignScheduledDate) {
        this.$notify('Selecione a data e horário de envio.', 'error')
        return
      }

      const scheduledDate = new Date(this.approveCampaignScheduledDate)
      if (Number.isNaN(scheduledDate.getTime())) {
        this.$notify('Data e horário de envio inválidos.', 'error')
        return
      }

      if (scheduledDate.getTime() < Date.now()) {
        this.$notify('A data e horário devem ser iguais ou posteriores ao momento atual.', 'error')
        return
      }

      this.approveCampaignLoading = true
      try {
        const result = await this.approve({
          campaignId: this.selectedCampaign.id,
          scheduledDate: this.$day(scheduledDate).format('YYYY-MM-DD HH:mm:ss'),
        })

        if (result === true) {
          this.$notify('Campanha aprovada com sucesso', 'success')
          this.closeApproveCampaignDialog()
          this.dialogCampaignDetail = false
          await this.fetchCampaigns()
        } else {
          const message = result?.response?.data?.message
          this.$notify(message || 'Erro ao aprovar campanha', 'error')
        }
      } catch (error) {
        console.error('Erro ao aprovar campanha:', error)
        this.$notify('Erro ao aprovar campanha', 'error')
      } finally {
        this.approveCampaignLoading = false
      }
    },

    async confirmAction() {
      if (!this.selectedCampaign) return

      try {
        const reportFile = this.uploads.general.fileSelected || null
        
        if (this.confirmDialogType === 'finalize') {
          const isUpdateReports = this.selectedCampaign.status === 'completed'
          const result = await this.finalize({
            campaignId: this.selectedCampaign.id,
            reportFile,
          })
          if (result === true) {
            this.$notify(
              isUpdateReports
                ? 'Relatório atualizado com sucesso'
                : 'Campanha finalizada com sucesso',
              'success',
            )
          } else {
            const message = result?.response?.data?.message
            this.$notify(
              message || (isUpdateReports
                ? 'Erro ao atualizar relatório'
                : 'Erro ao finalizar campanha'),
              'error',
            )
            return
          }
        } else if (this.confirmDialogType === 'cancel') {
          const isUpdateReports = this.selectedCampaign.status === 'cancelled'
          const result = await this.cancel({
            campaignId: this.selectedCampaign.id,
            reportFile,
          })
          if (result === true) {
            this.$notify(
              isUpdateReports
                ? 'Relatório atualizado com sucesso'
                : 'Campanha cancelada com sucesso',
              'success',
            )
          } else {
            const message = result?.response?.data?.message
            this.$notify(
              message || (isUpdateReports
                ? 'Erro ao atualizar relatório'
                : 'Erro ao cancelar campanha'),
              'error',
            )
            return
          }
        }

        this.confirmDialog = false
        this.dialogCampaignDetail = false
        await this.fetchCampaigns()
      } catch (error) {
        console.error('Erro ao executar ação:', error)
        this.$notify('Erro ao executar ação', 'error')
      }
    },

    resetAllUploads() {
      this.removeReportFile('general')

      if (this.$refs.generalReportFile) {
        this.$refs.generalReportFile.value = ''
      }
    },

    handleReportFile(kind, event) {
      const file = event.target.files[0]
      if (!file) return

      this.uploads[kind].loading = true

      try {
        // Validar tipo de arquivo - aceitar apenas Excel, CSV, DOCX e TXT
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          'application/vnd.ms-excel', // .xls
          'text/csv', // .csv
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
          'text/plain', // .txt
        ]
        
        const allowedExtensions = ['.xlsx', '.xls', '.csv', '.docx', '.txt']
        const fileName = file.name.toLowerCase()
        const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))
        const hasValidType = allowedTypes.includes(file.type) || file.type === ''

        if (!hasValidExtension && !hasValidType) {
          this.$notify('Por favor, selecione apenas arquivos Excel (.xlsx, .xls), CSV (.csv), DOCX (.docx) ou TXT (.txt)', 'error')
          event.target.value = ''
          this.uploads[kind].loading = false
          return
        }

        // Determinar o tipo de arquivo
        let fileType = 'file'
        if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls') || file.type.includes('spreadsheet') || file.type.includes('excel')) {
          fileType = 'excel'
        } else if (fileName.endsWith('.csv') || file.type === 'text/csv') {
          fileType = 'csv'
        } else if (fileName.endsWith('.docx') || file.type.includes('wordprocessing')) {
          fileType = 'docx'
        } else if (fileName.endsWith('.txt') || file.type === 'text/plain') {
          fileType = 'txt'
        }

        this.uploads[kind].fileSelected = file
        this.uploads[kind].fileName = file.name
        this.uploads[kind].fileType = fileType
        this.uploads[kind].previewContent = ''

        // Ler conteúdo para preview se for arquivo de texto
        if (fileType === 'txt' || fileType === 'csv') {
          const reader = new FileReader()
          reader.onload = (e) => {
            const content = e.target.result
            // Limitar preview a 1000 caracteres para não sobrecarregar
            this.uploads[kind].previewContent = content.length > 1000 
              ? content.substring(0, 1000) + '\n\n... (conteúdo truncado)'
              : content
            this.uploads[kind].loading = false
          }
          reader.onerror = () => {
            this.$notify('Erro ao ler arquivo', 'error')
            this.uploads[kind].loading = false
            this.removeReportFile(kind)
          }
          reader.readAsText(file)
        } else {
          // Para outros tipos, apenas criar URL de preview
          try {
            this.uploads[kind].previewUrl = URL.createObjectURL(file)
            this.uploads[kind].loading = false
          } catch (error) {
            console.error('Erro ao criar preview:', error)
            this.uploads[kind].loading = false
          }
        }
        
        // Limpar o input para permitir selecionar o mesmo arquivo novamente
        event.target.value = ''
      } catch (error) {
        console.error('Erro ao processar arquivo de mídia:', error)
        this.$notify('Erro ao processar arquivo. Tente novamente.', 'error')
        event.target.value = ''
        this.uploads[kind].loading = false
        this.removeReportFile(kind)
      }
    },

    removeReportFile(kind) {
      if (this.uploads[kind].previewUrl) {
        URL.revokeObjectURL(this.uploads[kind].previewUrl)
      }
      this.uploads[kind].fileSelected = null
      this.uploads[kind].fileName = ''
      this.uploads[kind].fileType = ''
      this.uploads[kind].previewUrl = ''
      this.uploads[kind].previewContent = ''
      this.uploads[kind].loading = false
      this.uploads[kind].isDragging = false
    },

    getMediaIcon(fileType) {
      switch (fileType) {
        case 'excel':
          return this.icons.mdiFileExcel
        case 'docx':
          return this.icons.mdiFileDocument
        case 'csv':
        case 'txt':
          return this.icons.mdiFileDocumentOutline
        default:
          return this.icons.mdiFile
      }
    },

    getFileTypeColor(fileType) {
      switch (fileType) {
        case 'excel':
          return 'success'
        case 'docx':
          return 'primary'
        case 'csv':
          return 'info'
        case 'txt':
          return 'grey'
        default:
          return 'grey'
      }
    },

    getFileTypeLabel(fileType) {
      switch (fileType) {
        case 'excel':
          return 'Excel'
        case 'docx':
          return 'Word'
        case 'csv':
          return 'CSV'
        case 'txt':
          return 'Texto'
        default:
          return 'Arquivo'
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },

    // Funções de drag and drop
    handleDragOver(kind, event) {
      event.preventDefault()
      this.uploads[kind].isDragging = true
    },

    handleDragLeave(kind, event) {
      event.preventDefault()
      this.uploads[kind].isDragging = false
    },

    handleDrop(kind, event) {
      event.preventDefault()
      this.uploads[kind].isDragging = false

      const files = event.dataTransfer.files
      if (files.length > 0) {
        const file = files[0]
        
        // Criar um evento fake para passar para handleMediaFile
        const fakeEvent = {
          target: {
            files: [file],
            value: '',
          },
        }
        
        this.handleReportFile(kind, fakeEvent)
      }
    },

  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}


/* Botão com borda tracejada */
.dashed-border {
  border-style: dashed !important;
  border-width: 2px !important;
}

.media-upload-btn {
  min-height: 60px !important;
  height: 60px !important;
}

/* Drop zone */
.drop-zone {
  transition: all 0.3s ease;
}

.drop-zone-active {
  transform: scale(1.02);
  opacity: 0.8;
}

.drop-zone-active .media-upload-btn {
  background-color: rgba(25, 118, 210, 0.1) !important;
  border-color: #1976d2 !important;
  border-width: 3px !important;
}

</style>
